import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { RequestState, RequestStateEnum } from "@app-common/http/RequestState";
import { EnkashModalService } from "@app-common/ui/enkash-modal.service";
import { numbersWithDecimal } from "@app-module/shared/shared.constants";
import { ToasterService, ToasterType } from "@app-service/toaster.service";
import { UserService } from "@app-service/user.service";
import { UnreportedReceiptService } from "@app/expense-management/services";
// import { ExpenseManagementService } from "@app/expense-management/services";
import { BsModalRef } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";

@Component({
    selector: "app-expense-approver-kg",
    templateUrl: "./expense-approver-kg.component.html",
    styleUrls: ["./expense-approver-kg.component.scss"],
    standalone: false
})
export class ExpenseApproverKgComponent implements OnInit {
  submitRequestState: RequestState;
  currency:string = JSON.parse(localStorage.getItem("BASE_CURRENCY_EXPENSE"));
  private valueChangesSub: Subscription[] = [];
  form: FormGroup = new FormGroup({
    comment: new FormControl(null, [
      Validators.maxLength(300),
      Validators.pattern(/^[^<>#*^!~`}{[\]%\\]+$/),
    ]),

    isPartialAmount: new FormControl(false),
    amountToApprove: new FormControl({ value: "", disabled: true }),
  });

  approveRejectModalRef: BsModalRef;
  referenceId: string;
  userType: string;
  amount: number;
  approvedAmount: any;
  showApprovalActions = true;
  merchant: string;
  expenseDate: string;
  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private modalService: EnkashModalService,
    private toastService: ToasterService,
    private unreportedReceiptService: UnreportedReceiptService
  ) {
    this.userService.showHaderImage(false);
    this.userService.showHaderSetting(false);
    this.userService.hideSideNav(true);
    this.submitRequestState = RequestState.init();
  }

  ngOnDestroy(): void {
    this.valueChangesSub.map((s) => s.unsubscribe);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.expenseDate = params["expenseDate"];
      this.amount = +params["amount"];
      this.merchant = params["merchant"];
      this.referenceId = params["referenceId"];
      this.userType = params["userType"];
      this.approvedAmount = params["approvedAmount"];
    });

    const amountToApprove = this.form.get("amountToApprove");
    this.valueChangesSub.push(
      this.form.get("isPartialAmount").valueChanges.subscribe((value) => {
        if (value) {
          amountToApprove.setValidators([
            Validators.required,
            Validators.pattern(numbersWithDecimal),
            Validators.max(this.amount),
            Validators.min(1),
          ]);
          amountToApprove.enable();
        } else {
          amountToApprove.reset();
          amountToApprove.clearValidators();
          amountToApprove.disable();
        }
        amountToApprove.updateValueAndValidity();
      })
    );
  }

  showApproveModal(action, tempRef) {
    this.approveRejectModalRef = this.modalService.showConfirmModal(tempRef);
    this.approveRejectModalRef.setClass("confirmation-modal-sm");
    this.modalService.onHide.subscribe(() => {
      this.form.reset();
    });
  }

  cancelConfirm() {
    this.approveRejectModalRef.hide();
    this.form.reset();
  }

  formActionRequestState(): RequestStateEnum {
    return this.submitRequestState.state;
  }

  performBatchAction(selectedBatchAction) {
    if (this.submitRequestState.isPending()) {
      return;
    }
    this.submitRequestState.pending();

    const payload = {
      amountToApprove:
        selectedBatchAction === "APPROVED"
          ? +this.form.get("amountToApprove").value || this.amount
          : this.amount,
      expenseRefId: this.referenceId,
      status: selectedBatchAction,
      userType: this.userType,
      comment: this.form.get("comment").value,
    };

    // if (
    //   selectedBatchAction !== "APPROVED" ||
    //   this.expenseIdArray.length > 1 ||
    //   !payload["amountToApprove"]
    // ) {
    //   delete payload["amountToApprove"];
    // }

    console.log("Actions -> ", payload);

    this.valueChangesSub.push(
      this.unreportedReceiptService.expenseEmailApprover(payload).subscribe(
        (res) => {
          this.approvedAmount = res.payload.approvedAmount;
          this.showApprovalActions = false;
          this.submitRequestState.completed();
          const msg =
            selectedBatchAction === "APPROVED"
              ? "Selected expenses approved successfully!"
              : selectedBatchAction === "REJECTED"
              ? "Selected expenses rejected."
              : "Selected expenses were sent to reportee for update.";
          this.toastService.showToaster(msg, ToasterType.SUCCESS);
          this.approveRejectModalRef.hide();
          this.form.reset();
        },
        (err) => {
          const error =
            (err && err["error"] && err["error"]["response_message"]) ||
            "Failure";
          this.submitRequestState.rejected();
          this.toastService.showToaster(error, ToasterType.ERROR);
          this.approveRejectModalRef.hide();
          this.form.reset();
        }
      )
    );
  }
}
